import React, { useState } from 'react'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import PinOutlinedIcon from '@mui/icons-material/PinOutlined';
import PinUpdate from './Pin';
import PasswordUpdate from './ChangePassword';

const securityActions = [
  {
    title: 'Update PIN',
    description: 'Change or reset your HalalWealth PIN',
    icon: PinOutlinedIcon,
    action: 'pin',
  },
  {
    title: 'Update Password',
    description: 'Change or reset your HalalWealth password',
    icon: LockOutlinedIcon,
    action: 'password',
  },
];

function Security() {
    const [open, setOpen] = useState(false)
    const handleOpen = () => setOpen(true)
    const handleClose = () => setOpen(false)
    const [open1, setOpen1] = useState(false)
    const handleOpen1 = () => setOpen1(true)
    const handleClose1 = () => setOpen1(false)
    const handleAction = (action) => {
        if (action === 'pin') {
            handleOpen()
            return
        }

        handleOpen1()
    }

    return (
        <div className='max-w-2xl'>
            <PinUpdate
                open={open}
                handleClose={handleClose}
            />
            <PasswordUpdate
                open={open1}
                handleClose={handleClose1}
            />

            <div className='space-y-4'>
                {securityActions.map(({ title, description, icon: Icon, action }) => (
                    <div
                        key={title}
                        className='flex items-center justify-between gap-6 rounded-lg  border-gray-200 bg-white p-5'
                    >
                        <div className='flex items-center gap-4'>
                            <div className='flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-bg text-primary-color'>
                                <Icon fontSize='small' />
                            </div>
                            <div>
                                <h1 className='mb-1 text-[18px] font-bold text-[#1E222B]'>{title}</h1>
                                <p className='text-[15px] text-[#44474E]'>{description}</p>
                            </div>
                        </div>

                        <button
                            type='button'
                            onClick={() => handleAction(action)}
                            className='shrink-0 rounded-lg bg-primary-color px-4 py-2 text-[14px] font-bold text-white'
                        >
                            Update
                        </button>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Security
